import React, { useState,useEffect } from "react";

import axios from "axios";



import "./home-footer.component.scss";

const PANEL = {
  QUICK_ACCESS: "QUICK_ACCESS",
  SUPPORT: "SUPPORT",
  SOLUTIONS: "SOLUTIONS",
  ABOUT: "ABOUT",
};

export default function HomeFooter() {
  

  const [openPanel, setOpenPanel] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => {
    axios("https://assets.airtel.in/static-assets/b2b-ui-components-lib/json/footer.json").then( (res) => setData(res.data) )
  }, []);


  function isPanelOpen(panel) {
    return panel === openPanel;
  }

  function togglePanel(panel) {
    if (panel === openPanel) {
      setOpenPanel(null);
    } else {
      setOpenPanel(panel);
    }
  }

  const renderQuick = () => {
    return data.QuickAccess.item.map((items,index) => (
      <li key={index}><a href={items.Url }>{items.heading}</a></li>
      ))
  }
  
  const renderSupport = () => {
    return data.Support.item.map((items,index) => (
      <li key={index}><a href={items.Url }>{items.heading}</a></li>
      ))
  } 
  
  const renderSolutions = () => {
    return data.Solutions.item.map((items,index) => (
      <li key={index}><a href={items.Url }>{items.heading}</a></li>
      ))
  }

  const renderAbout = () => {
    return data.AboutAirtel.item.map((items, index) => (
      <li key={index}><a href={items.Url}>{ items.heading}</a></li>
      
    ))
    
  } 
if (!data) return null;
  return (
    <section className="border-b">
    <div className="container mx-auto flex flex-wrap pt-4">
    <div className="w-full mb-4">
    <footer className="abfooter">
      <div className="container">
        <div className="row">
          <div
            className="flgsm12 flgmd3 flglg2"
          >
            
            <h5
              onClick={() => togglePanel(PANEL.QUICK_ACCESS)}
              className={isPanelOpen(PANEL.QUICK_ACCESS) ? "active" : ""}
            >
              
                Quick Access
              
            </h5>
            <ul
              className={isPanelOpen(PANEL.QUICK_ACCESS) ? "active" : ""}
            >
              {renderQuick()} 
            </ul>
          </div>
          <div
            className={`${isPanelOpen(PANEL.SUPPORT) ? "active" : ""} flgsm12
               flgmd3 flglg2`}
          >
            <h5
              onClick={() => togglePanel(PANEL.SUPPORT)}
              className={isPanelOpen(PANEL.SUPPORT) ? "active" : ""}
            >
              Support
            </h5>
            <ul className={isPanelOpen(PANEL.SUPPORT) ? "active": ""}>
              { renderSupport()}
            </ul>
          </div>
          <div
            className="flgsm12 flgmd3 flglg2"
          >
            <h5
              onClick={() => togglePanel(PANEL.SOLUTIONS)}
              className={isPanelOpen(PANEL.SOLUTIONS) ? "active" : ""}
            >
              Solutions
            </h5>
            <ul className={isPanelOpen(PANEL.SOLUTIONS) ? "active" : ""}>
              { renderSolutions()}
            </ul>
          </div>

          <div
            className="flgsm12 flgmd3 flglg3"
          >
            <h5
              onClick={() => togglePanel(PANEL.NEW_CONNECTION)}
              className={isPanelOpen(PANEL.NEW_CONNECTION) ? "active" : ""}
            >
              About Airtel
            </h5>
            <ul
              className={isPanelOpen(PANEL.NEW_CONNECTION) ? "active" : ""}
            >
              {renderAbout()}
            </ul>
          </div>
          <div
            className="flgsm12 flgmd3 flglg3"
          >
            <div className="row">
              <div
                className="flgsm12 flgmd5 flglg12"
              >
                <div className="socialmedia">
                  <h4>Follow Us</h4>
                  <div className="socialIcon">
                    <ul>
                      <li className="linked">
                        <a
                          href="https://www.linkedin.com/company/airtel-business/"
                          target="_blank"
                        >
                          <img
                            src="https://assets.airtel.in/static-assets/b2b-ui-components-lib/images/business/linkedin.svg"
                            alt=""
                          />
                        </a>
                      </li>
                      <li className="twitter">
                        <a
                          href="https://twitter.com/airtelindia/"
                          target="_blank"
                        >
                          <img
                            src="https://assets.airtel.in/static-assets/b2b-ui-components-lib/images/business//twitter.svg"
                            alt=""
                          />
                        </a>
                      </li>

                      <li className="youtube">
                        <a
                          href="https://www.youtube.com/channel/UC62RQR1TkP_945zTN6Jwecg"
                          target="_blank"
                        >
                          <img
                            src="https://assets.airtel.in/static-assets/b2b-ui-components-lib/images/business/youtube.svg"
                            alt=""
                          />
                        </a>
                      </li>
                      <li className="facebook">
                        <a
                          href="https://www.facebook.com/Airtel-Business-103025222146580"
                          target="_blank"
                        >
                          <img
                            src="https://assets.airtel.in/static-assets/b2b-ui-components-lib/images/business/facebook.svg"
                            alt=""
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div
                className="flgsm12 flgmd3 flglg12"
              >
                <div className="supportemailwrap">
                  <div className="supportemail">
                    <h4>Airtel Business Support:</h4>
                    <a href="mailto:enterprise@in.airtel.com">enterprise@in.airtel.com</a>
                  </div>
                </div>
              </div>
              <div
                className="flgsm12 flgmd4 flglg12"
              >
                {/* <div className="loginhub">
                  <a
                    href="https://www.airtel.in/business/enterprise-hub/login/" target="_blank"
                    className="btn" type="button"
                  >
                    Login to Thanks for Business
                  </a>
                </div> */}
                <div className="otherlinks">
                  <div className="visitlink">
                    Visit &nbsp;
                    <a href="https://www.airtel.in/" target="_blank">
                      airtel.in
                    </a>
                  </div>
                  <div className="downloadlink">
                    Download&nbsp;
                    <a
                      href="https://www.airtel.in/airtel-thanks-app/"
                      target="_blank"
                    >
                      Airtel Thanks
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
             
      <div className="bottomlinks">
        <div className="container">
          <div className="footerbottom">
            <div className="footerlinks">
              <ul>
                <li>
                  <a
                    href="https://www.airtel.in/mobile/terms-conditions?icid=footer"
                    target="_blank"
                  >
                    Terms & Conditions
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.airtel.in/privacy-policy/"
                    target="_blank"
                  >
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="https://www.airtel.in/cookie-notice/" target="_blank">
                    Cookie Notice
                  </a>
                </li>
                <li>
                  <a href="https://www.airtel.in/airtel-dnd/" target="_blank">
                    Do Not Disturb List
                  </a>
                </li>
                {/*  <li>
                  <a href="#">Site Map</a>
                </li> */}
                <li>
                  <a
                    href="https://assets.airtel.in/static-assets/selfcare/pdf/Code_of_Conduct.pdf"
                    target="_blank"
                  >
                    Code of Conduct
                  </a>
                </li>
              </ul>
            </div>
            <div className="copyright">
              {new Date().getFullYear()} Airtel India. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
    </div>
    </div>
    </section>
  );
}
